import { merchantActionTypes } from '../action-types';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { formikErrorHandler } from '../../../utils/formikUtils';
import { getFormattedAccountFields, IFormattedAccountFieldsProps } from '../../../constants/accounts/account-form';
import * as React from 'react';
import { IAccount, IAction } from '../merchant-interfaces';
import { GET } from '../../store-helper';

export const fetchAccountList = async (dispatch: React.Dispatch<IAction>): Promise<void> => {
	try {
		dispatch({ type: merchantActionTypes.SET_ACCOUNT_LIST_LOADING, payload: true });

		const data = await GET({ pathname: `${BASE_URL.MERCHANTS}/accounts` });

		let formattedAccountsList = [];

		if (data) {
			formattedAccountsList = data.map(item => ({
				value: item.id,
				label: item.name
			}));
		}
		dispatch({ type: merchantActionTypes.FETCH_ACCOUNT_LIST, payload: data ?? [] });
		dispatch({ type: merchantActionTypes.SET_ACCOUNTS_LIST_SELECTOR, payload: formattedAccountsList });
	} catch (e) {
		dispatch({ type: merchantActionTypes.SET_ACCOUNT_LIST_LOADING, payload: false });
	}
};

export const setAccount = async (
	dispatch: React.Dispatch<IAction>,
	formik: any,
	account: IAccount,
	setChosenAccount: (value: IAccount) => void,
	onSuccess: () => void,
	onError: () => void
): Promise<void> => {
	dispatch({ type: merchantActionTypes.SET_NEW_ACCOUNT_LOADING, payload: true });
	if (!formik.isValid) return;
	try {
		const data: IFormattedAccountFieldsProps = getFormattedAccountFields(formik.values);
		if (account?.id) {
			data.id = account.id;
			await axios.put(`${BASE_URL.MERCHANTS}/accounts`, data);
			setChosenAccount && setChosenAccount(null);
		} else {
			await axios.post(`${BASE_URL.MERCHANTS}/accounts`, data);
		}
		onSuccess();
		await fetchAccountList(dispatch);
		dispatch({ type: merchantActionTypes.SET_NEW_ACCOUNT_LOADING, payload: false });
	} catch (e) {
		console.log('setAccount error', e.response);
		if (e.response?.data?.General) {
			onError();
		} else if (e.response.data) {
			formikErrorHandler({ formik, data: e.response?.data });
		}
		dispatch({ type: merchantActionTypes.SET_NEW_ACCOUNT_LOADING, payload: false });
	}
};
